$(document).ready(async function () {
  let allCookies = document.cookie;
  let authCookieName = "auth=";
  let start = allCookies.indexOf(authCookieName);
  let authCookieValue = null;
  if (start !== -1) {
    start += authCookieName.length;
    let end = allCookies.indexOf(';', start);
    if (end === -1) end = allCookies.length;
    authCookieValue = decodeURIComponent(allCookies.substring(start, end));
  }
  if (authCookieValue !== null) {
    $('.result-page').removeClass('hidden');
    $('.third-part-wrapper').addClass('hidden');
    $('.first-part-wrapper').addClass('hidden');
    $('.chartTitle h2').text('THANK YOU FOR MAKING A DIFFERENCE!')
  }

 $('.data_info').on('click', function() {
   loadData()
 })
$("#show_questionnaire_result_data").on("click",function () {
        loadData()
  $('.content-validity').addClass('hidden')
  $('.getStarted-part-wrapper').removeClass('hidden')
   $('.result-page').removeClass('hidden');
 $('.third-part-wrapper').addClass('hidden');
 })    
  
  $("button.button--primary.button--fixed.icon-with-text.third--btn").on('click', function() {
    loadData();
});

function loadData(){
  $.ajax({
    type: "GET",
    url: "https://defend-backend-integration-icd1.onrender.com/api/v1/report",
    beforeSend:function () {
      const resultSection = document.querySelector("#result_section")
     if (!resultSection.classList.contains("hidden")) {
            const loadingDiv = document.createElement("div");
            loadingDiv.id = "loading_div";
            loadingDiv.className="spinner"
            loadingDiv.innerText=" "
            resultSection.appendChild(loadingDiv);
        }
      
    },
    success: function (response) {
 
      const loadingDiv = document.getElementById("loading_div");
        if (loadingDiv) {
            loadingDiv.remove();
        }

      if(response.statusCode!==200){
        document.querySelector('#result_section').innerHTML = "<h2 class='text-center'>Something went wrong with this action. Please refresh the page and try again.</h2>"
      }
      
      // Bar chart
      const seriesData = response.data.barAndChartData;
      const categories = seriesData.map((item) => item.medication.toUpperCase());
      const counts = seriesData.map((item) => item.totalCount);
      const ageGroups = seriesData.map((item) => item.ageGroups);
      const totalSubmissionCount = seriesData.reduce((sum, medication) => sum + medication.totalCount, 0);

      // Function to convert age group to numeric value
      function ageGroupToValue(ageGroup) {
        switch (ageGroup) {
          case "18-25": return 1;
          case "26-34": return 2;
          case "35-45": return 3;
          case "46+": return 4;
          default: return 0;
        }
      }

      // Find the highest age group for each medication and create the result array
      const barChartSeriesData = seriesData.map(medication => {
        const highestAgeGroup = medication.ageGroups.reduce((max, current) => {
          return ageGroupToValue(current.age) > ageGroupToValue(max.age) ? current : max;
        });
        return ageGroupToValue(highestAgeGroup.age);
      });

      console.log(seriesData,"SERI")
Highcharts.chart('dataContainer', {
    chart: {
        type: 'column',
        backgroundColor: '#3F3F3F ',
        borderRadius: '10px',
        spacingTop: 50, // Increased top padding for the chart
        marginRight: 30,
        height: 500
    },
    title: {
        text: `POSITIVE CASES BY <span style="color: #e7ff50;">AGE GROUP</span>`,
        style: {
            color: '#ffffff',
            fontFamily: 'Clash Display',
            fontWeight: 'normal',
            marginTop: 40 // Additional space below the title
        }
    },
    subtitle: {
        text: totalSubmissionCount + ' TOTAL SUBMISSIONS',
        style: {
            color: '#ffffff',
            fontFamily: 'Clash Display',
            fontWeight: 'normal'
        }
    },
    xAxis: {
        categories: categories,
        crosshair: true,
        labels: {
            style: {
                color: '#ffffff'
            },
            rotation: 45,
            x: 0,
            y: 20
        },
        lineColor: '#FFFFFF',
        lineWidth: 2
    },
    yAxis: {
        title: {
            text: 'Age group',
            style: {
                color: '#e7ff50'
            },
            margin: 20
        },
        min: 0,
        max: 4,
        tickInterval: 1,
        style: {
            fontSize: '12px'
        },
        labels: {
            style: {
                color: '#ffffff'
            },
            formatter: function () {
                const ageGroups = ['0', '18-25', '26-34', '35-45', '46+'];
                return ageGroups[this.value];
            }
        }
    },
    tooltip: {
        enabled: false
    },
    plotOptions: {
        series: {
            cursor: 'pointer',
            point: {
                events: {
                    mouseOver: function () {
                        showCustomTooltip(this.category, this.y, this.series.chart, this, 'dataContainer-custom-tooltip', 'dataContainer-wrapper');
                    }
                }
            }
        }
    },
    legend: {
        itemStyle: {
            color: '#e7ff50',
            cursor: 'default',
            pointerEvents: 'none',
            listStyleType: 'none'
        },
        itemHoverStyle: {
            color: '#ffffff'
        },
        symbolHeight: 0,
        symbolWidth: 0
    },
    series: [{
        name: 'DRUG TYPE',
        data: barChartSeriesData,
        showInLegend: true,
        legendSymbol: 'none',
        color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
                [0, '#e7ff50'],
                [1, '#e7ff50']
            ]
        }
    }],
    exporting: {
        enabled: false,
        buttons: {
            contextButton: {
                menuItems: [
                    {
                        text: 'Download CSV',
                        onclick: function () {
                                          
                 const csvData = seriesData.flatMap(item => 
                          item.ageGroups.map(ageGroup => {
                              const medication = item.medication;
                              const age = ageGroup.age;
                              const count = ageGroup.count;
                              return `${medication},${age},${count}`;
                          })
                      ).join('\n');
              
                      const csvContent = `Medication,Age Group,Count\n${csvData}`;
                      const blob = new Blob([csvContent], { type: 'text/csv' });
                      const link = document.createElement('a');
                      link.href = URL.createObjectURL(blob);
                      link.download = 'chart-data.csv';
                      link.click();
                        }
                    }
                ]
            }
        }
    }
});



      // custom
      mouseOutInit();
      function showCustomTooltip(category, value, chart, point, toolTipId, cartItemClass) {
        const tooltip = document.getElementById(toolTipId);
        // Find the object with the matching medication category
        const object = seriesData.find(({ medication }) => medication.toUpperCase() === category.toUpperCase());
        const totalCount = seriesData.filter(({ medication }) => medication.toUpperCase() === category.toUpperCase())[0].totalCount

        if (!object) {
          console.warn(`No data found for category: ${category}`);
          return;
        }

        // Create tooltip lines from the object's age groups and states
        const tooltipLines = object.ageGroups.flatMap(ageGroup =>
        ageGroup.states.flatMap(state => 
        state.cities.flatMap(city => `${ageGroup.age} - ${city.name}, ${state.state} - ${ageGroup.createdAt}`)
    )
);

        // Generate the tooltip content
        const generateTooltipContent = (lines, maxLines = 10) =>
          lines.slice(0, maxLines).map(line => `<div class="tooltip-item">${line}</div>`).join('');

        // Get the position and size of the hovered bar
        const pointElement = chart.series[0].data[point.index].graphic.element;
        const rect = pointElement.getBoundingClientRect();
        const containerRect = document.querySelector(`.${cartItemClass}`).getBoundingClientRect();
        const tooltipWidth = tooltip.offsetWidth;
        const containerWidth = containerRect.width;

        // Calculate left position and adjust for the last few bars
        const isNearEnd = point.index >= chart.series[0].data.length - 3;
        let leftPosition = rect.left + rect.width / 2 - containerRect.left;

        if (isNearEnd) {
          leftPosition = containerWidth - 100;
        }

        // Set the tooltip HTML content
        tooltip.innerHTML = `
    <div class="tooltip-scroll">
      <div class="tooltip-title">
        <span>${tooltipLines.length}</span> TOTAL SUBMISSIONS FOR <strong>${category.toUpperCase()}</strong>
      </div>
      <div class="tooltip-content">
        ${generateTooltipContent(tooltipLines)}
        ${tooltipLines.length > 10
            ? '<span class="tooltip-link" id="show-more">Show More...</span>'
            : ''
          }
      </div>
    </div>
  `;

        // Position the tooltip
        tooltip.style.left = `${leftPosition}px`;
        tooltip.style.top = `${rect.top + rect.height - containerRect.top + 2}px`;
        tooltip.style.display = 'block';

        // Add event listener for "Show More" if applicable
        const showMoreButton = document.getElementById('show-more');
        if (showMoreButton) {
          showMoreButton.addEventListener('click', () => {
            document.querySelector(".tooltip-content").classList.add("show-more");
            document.querySelector(".tooltip-content").innerHTML = tooltipLines.map(line => `<div class="tooltip-item">${line}</div>`).join('');
          });
        }
      }

     
      
      function mouseOutInit() {
        const containerWrapper = document.querySelector('.dataContainer-wrapper');
        containerWrapper.addEventListener('mouseleave', function () {
          hideCustomTooltip('dataContainer-custom-tooltip');
        });

        const pieChartWrapper = document.querySelector('.pieChart-wrapper');
        pieChartWrapper.addEventListener('mouseleave', function () {
          hideCustomTooltip('pie-custom-tooltip');
        });

        const mapWrapper = document.querySelector('.map-data-wrapper');
        mapWrapper.addEventListener('mouseleave', function () {
          hideCustomTooltip('map-custom-tooltip');
        });
      }

      function hideCustomTooltip(toolTipId) {
        const tooltip = document.getElementById(toolTipId);
        tooltip.style.display = 'none';
      }
      // custom

      // Pie chart
      const pieData = response.data?.barAndChartData.map((item) => ({
        name: item.medication,
        y: item.percentage,
      }));

 Highcharts.chart('pieChart', {
  chart: {
    type: 'pie',
    backgroundColor: '#3F3F3F ',
    borderRadius: '10px',
    spacingTop: 20,
    height:500,
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            enabled: false
          },
          plotOptions: {
            pie: {
              dataLabels: {
                distance: -30,
                style: {
                  fontSize: '28px'
                }
              }
            }
          }
        }
      }]
    }
  },
  title: {
    text: 'POSITIVE CASES BY <span style="color: #e7ff50;"> DRUG TYPE </span>',
    style: {
      color: "#FFFFFF",
      fontFamily: "Clash Display",
      fontWeight: "normal",
      marginTop: 30
    }
  },
  subtitle: {
    text: totalSubmissionCount + ' TOTAL SUBMISSIONS',
    style: {
      color: "#FFFFFF",
      fontFamily: "Clash Display",
      fontWeight: "normal",
      fontSize: '12px'
    }
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      cursor: 'pointer',
      point: {
        events: {
          mouseOver: function () {
            showCustomTooltipPieChart(this, 'pie-custom-tooltip', 'pieChart-wrapper');
          }
        }
      }
    },
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        useHTML: true,
        formatter: function () {
          let rotationAngle, fontSizeValue;
          if (this.percentage < 4) {
            rotationAngle = 10;
            fontSizeValue = 8;
          } else if (this.percentage < 7) {
            rotationAngle = 30;
            fontSizeValue = 10;
          } else if (this.percentage < 10) {
            rotationAngle = 45;
            fontSizeValue = 12;
          } else {
            rotationAngle = 0;
            fontSizeValue = 14;
          }
          return '<div style="transform: rotate(' + rotationAngle + 'deg); color: #58595b; font-size: '+ fontSizeValue +'px; font-weight: 400; text-align: center;">' + this.point.name + '<br/>' + this.percentage.toFixed(1) + '%' + '</div>';
        },
        distance: -50
      },
      borderWidth: 2,
      borderColor: "#58595b",
      states: {
        hover: {
          enabled: true,
          brightness: 0.2,
          color: "#ffffff"
        }
      }
    }
  },
  series: [{
    name: 'Percentage',
    colorByPoint: true,
    data: pieData.map((item) => ({
      name: item.name.toUpperCase(),
      y: item.y,
      color: "#e7ff50"
    }))
  }],
  legend: {
    itemStyle: {
      color: "#FFFFFF"
    }
  },
exporting: {
        enabled: false,
        buttons: {
            contextButton: {
                menuItems: [
                    {
                        text: 'Download CSV',
                        onclick: function () {
                                          
                 const csvData = seriesData.flatMap(item => 
                          item.ageGroups.map(ageGroup => {
                              const medication = item.medication;
                              const age = ageGroup.age;
                              const count = ageGroup.count;
                              return `${medication},${age},${count}`;
                          })
                      ).join('\n');
              
                      const csvContent = `Medication,Age Group,Count\n${csvData}`;
                      const blob = new Blob([csvContent], { type: 'text/csv' });
                      const link = document.createElement('a');
                      link.href = URL.createObjectURL(blob);
                      link.download = 'pie-chart-data.csv';
                      link.click();
                        }
                    }
                ]
            }
        }
    }
});


function showCustomTooltipPieChart(point, toolTipId, chartWrapperClass) {
  const tooltip = document.getElementById(toolTipId);
  const category = point.name;
  const totalCount = seriesData.filter(({ medication }) => medication.toUpperCase() === category.toUpperCase())[0].totalCount;
  const value = totalCount;
  const object = seriesData.find(({ medication }) => medication.toUpperCase() === category.toUpperCase());

  if (!object) {
    console.warn(`No data found for category: ${category}`);
    return;
  }

        // Create tooltip lines from the object's age groups and states
 const tooltipLines = object.ageGroups.flatMap(ageGroup =>
  ageGroup.states.flatMap(state =>
    state.cities.map(city => `${ageGroup.age} - ${city.name}, ${state.state} - ${ageGroup.createdAt}`)))
  
  
  const generateTooltipContent = (lines, maxLines = 10) => lines.slice(0, maxLines).map(line => `<div class="tooltip-item">${line}</div>`).join('');

  const chartContainer = document.querySelector(`.${chartWrapperClass}`);
  const chartRect = chartContainer.getBoundingClientRect(); 

  tooltip.innerHTML = `
    <div class="tooltip-scroll">
      <div class="tooltip-title">
        <span>${tooltipLines.length}</span> TOTAL SUBMISSIONS FOR <strong>${category.toUpperCase()}</strong>
      </div>
      <div class="tooltip-content-pie">
        ${generateTooltipContent(tooltipLines)}
        ${tooltipLines.length > 10 ? '<span class="tooltip-link" id="show-more-pie">Show More...</span>' : ''}
      </div>
    </div>
  `;

     // Position the tooltip
  if (window.innerWidth <= 500) { 
    tooltip.style.left = '50%';
    tooltip.style.transform = 'translateX(-50%)';
    tooltip.style.top = '85%';
  } else {
    const { x, y, start, end } = point.shapeArgs;
    const angle = (start + end) / 2;
    const chartCenterX = chartRect.left + chartRect.width / 2;
    const chartCenterY = chartRect.top + chartRect.height / 2;
    const radius = Math.min(chartRect.width, chartRect.height) / 2;
    const extraDistance = 10;

    const adjustedTooltipX = (chartCenterX + (radius + extraDistance) * Math.cos(angle)) / 2;
    const adjustedTooltipY = (chartCenterY + (radius + extraDistance) * Math.sin(angle)) / 2;
    tooltip.style.left = `${adjustedTooltipX + 190}px`;
    tooltip.style.top = `${adjustedTooltipY}px`;
  }
  tooltip.style.display = 'block';

  const showMoreButton = document.getElementById('show-more-pie');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', () => {
      document.querySelector(".tooltip-content-pie").classList.add("show-more");
      document.querySelector(".tooltip-content-pie").innerHTML = tooltipLines.map(line => `<div class="tooltip-item">${line}</div>`).join('');
    });
  }

  // Add touch-friendly close button
  const closeButton = document.createElement('div');
  closeButton.innerHTML = '×';
  closeButton.style.position = 'absolute';
  closeButton.style.top = '5px';
  closeButton.style.right = '5px';
  closeButton.style.fontSize = '20px';
  closeButton.style.cursor = 'pointer';
  closeButton.onclick = () => { tooltip.style.display = 'none'; };
  // tooltip.appendChild(closeButton);
}

  



 

   
 fetch('https://code.highcharts.com/mapdata/countries/us/us-all.topo.json')

       .then(response => response.json())
       .then(USMapData => {
  

  function showCustomTooltipMap(name, value,state, event) {
    const tooltip = document.getElementById('map-custom-tooltip');
    const mapContainer = document.querySelector('.map-data-wrapper');
    const mapRect = mapContainer.getBoundingClientRect();

    const location = response.data.filteredResponse.find(
        (loc) => loc.name.toUpperCase() === name.toUpperCase()
    );

const tooltipLines = [];

// Step 1: Populate the tooltipLines array with formatted strings
location.data.forEach(item => {
    item.ageGroups.forEach(ageGroup => {
        ageGroup.medications.forEach(medication => {
            const line = `${medication.medication} - ${ageGroup.age} - ${ageGroup.createdAt}`;
            tooltipLines.push(line);
        });
    });
});

// Log the tooltip lines


    // Reset tooltip size to auto to get its natural dimensions
    tooltip.style.width = 'auto';
    tooltip.style.height = 'auto';

    const tooltipContent = tooltipLines.slice(0, 10).map(line => `<div class="tooltip-item line-height-1">${line}</div>`).join('');
    tooltip.innerHTML = `
        <div class="tooltip-scroll">
        <div class="tooltip-title">
            <span> ${value}</span> TOTAL SUBMISSIONS FOR
            <strong>${name} , ${state} </strong>
        </div>
        <div class="tooltip-content-map">
            ${tooltipContent} 
            ${tooltipLines.length > 10 ? '<span class="tooltip-link" id="show-more-map">Show More...</span>' : ''}
        </div>
        </div>
    `;

    tooltip.style.visibility = 'hidden';
    tooltip.style.display = 'block';

    const padding = 10; 
    let tooltipX, tooltipY;
    tooltipX = event.chartX + padding;
    tooltipY = event.chartY + padding;

    if (window.innerWidth <= 500) { 
        tooltip.style.left = '55%';
        tooltip.style.transform = 'translateX(-50%)';
        tooltip.style.top = '75%';
    } else {
        tooltip.style.left = `${tooltipX}px`;
        tooltip.style.top = `${tooltipY}px`;
    }
    tooltip.style.visibility = 'visible';

    // Add event listener for "Show More"
    const showMoreButton = document.getElementById('show-more-map');
    if (showMoreButton) {
        showMoreButton.addEventListener('click', function () {
            if (tooltipLines.length >= 2) {
                document.querySelector(".tooltip-content-map").classList.add("show-more-map");
                document.querySelector(".tooltip-content-map").innerHTML = tooltipLines.map(line => `<div class="tooltip-item">${line}</div>`).join('');
            }
        });
    }
}

   function hideCustomTooltip() {
        const tooltip = document.getElementById("custom-tooltip");
        tooltip.style.visibility = "hidden";
      }

const formattedCityData = response.data.filteredResponse.map(city => ({
    name: city.name,
    lat: city.lat,
    lon: city.lon,
    value: city.data.reduce((sum, item) => sum + item.ageGroups.reduce((innerSum, ageGroup) => innerSum + ageGroup.medications.reduce((medSum, medication) => medSum + medication.count, 0), 0), 0)
}));


// TESTING
   const dataSeries = response.data.filteredResponse.map((city) => ({
        name: city.name,
        lat: city.lat,
        lon: city.lon,
     state:city.state,
        value: city.data.length,
      }));

         console.log(response.data.filteredResponse)
const mapCSVDATA = response.data.filteredResponse
Highcharts.mapChart("map-data", {
    chart: {
        map: USMapData,
        events: {
            load() {
                const chart = this;
                chart.series[1].setData(dataSeries); // Add city points
            },
        },
        backgroundColor: "#3F3F3F ",
        borderRadius: "10px",
        spacingTop: 20,
        height:500
    },
    title: {
        text: 'POSITIVE CASES BY <span style="color: #e7ff50;"> LOCATION</span>',
        align: "center",
        style: {
            color: "#FFFFFF",
            fontFamily: "Clash Display",
            fontWeight: "normal",
            marginTop: 30
        }
    },
    subtitle: {
        // text: response?.data.filteredResponse.length + " SUBMISSIONS",
        text: totalSubmissionCount + " TOTAL SUBMISSIONS" ,
        align: "center",
        style: {
            color: "#FFFFFF",
            fontFamily: "Clash Display",
            fontWeight: "normal"
        }
    },
    tooltip: {
        enabled: false,
        formatter: function () {
            return `${this.point.name}: ${this.point.value}`;
        }
    },
 exporting: {
    enabled: false,
    buttons: {
        contextButton: {
            menuItems: [
                {
                    text: 'Download CSV',
                    onclick: function () {
                         const csvData = mapCSVDATA.flatMap(city =>
                            city.data.flatMap(entry =>
                                entry.ageGroups.flatMap(ageGroup =>
                                    ageGroup.medications.map(medicationData => {
                                        const cityName = city.name;       // City name
                                        const stateName = city.state;     // State name
                                        const age = ageGroup.age;          // Age group
                                        const medication = medicationData.medication; // Medication name
                                        const count = medicationData.count; // Medication count
                                        return `${stateName},${cityName},${age},${medication},${count}`;
                                    })
                                )
                            )
                        ).join('\n');

                        const csvContent = `State,City Name,Age Group,Medication,Count\n${csvData}`;
                        const blob = new Blob([csvContent], { type: 'text/csv' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = 'map-data.csv';
                        link.click();
                    }
                }
            ]
        }
    }
},
    legend: {
        enabled: false
    },
    mapNavigation: {
        enabled: true,
        buttonOptions: {
            verticalAlign: 'bottom'
        }
    },

    plotOptions: {
        series: {
            cursor: "pointer",
          colorAxis: {
    visible: false, 
    min: 1,
    type: "logarithmic",
    minColor: "#FF0000",
    maxColor: "#FF0000"  
},
            point: {
                events: {
                    mouseOver: function () {
                        const chart = this.series.chart;
                        const city = this; 
                        // Find the corresponding state by name
                        const stateName = city.options.state;
                        const stateSeries = chart.series[0]; 
                        stateSeries.data.forEach(statePoint => {
                            if (statePoint.name === stateName) {
                                statePoint.update({
                                    color: '#FFFF00' 
                                }, false);
                            } else {
                                statePoint.update({
                                    color: '#808080' 
                                }, false);
                            }
                        });
                        chart.redraw();
                        showCustomTooltipMap(city.name, city.value, city.options.state, event);
                    },
                    mouseOut: function () {
                        const stateSeries = this.series.chart.series[0];

                        stateSeries.data.forEach(statePoint => {
                            statePoint.update({
                                color: null // Reset to default color
                            }, false);
                        });

                        this.series.chart.redraw();
                    }
                }
            },
            states: {
                hover: {
                    enabled: false
                },
                inactive: {
                    opacity: 1 
                }
            }
        }
    },
    series: [{
        mapData: USMapData,
        joinBy: ['name', 'name'],
        name: 'State Data',
        nullColor: '#d0d0d0',  
        showInLegend: false,
       borderColor: '#5d5e60',
        borderWidth: 1.1,

        states: {
            hover: {
                enabled: false 
            },
            normal: {
                animation: false
            }
        },
        dataLabels: {
            enabled: false,
            format: '{point.name}',
            style: {
              fontSize: "10px",
              color: "#FFFFFF",
             
              backgroundColor: "#808080"
            }
        },
    },
  {
     type: "mappoint",
    name: "Cities",
    color: "#6a6b6dc9",
    marker: {
        radius: 14, // Marker radius
    },
   dataLabels: {
    enabled: true,
    format: "{point.value}",
    style: {
        color: "#e7ff50", 
        textAlign: "center",
        fontSize: '14px',
        textOutline: 'none',  
        borderColor: null,     
        borderWidth: 0,        
    },
    align: "center",        
    verticalAlign: "middle",
    x: 2,  // Horizontal offset, adjust if necessary
    y: -1  // Vertical offset, adjust if necessary
},
    data: dataSeries,
}
]
});

// const tableData = response.data.formattedTableData;
// const rowsPerPage = 10;
// let currentPage = 1;

// function createTable() {
//     const container = document.getElementById("formatted_table_data");
//   const tableHeading = document.getElementById("tableHeading")
//   tableHeading.innerHTML = `${tableData.length} submission`
//     container.innerHTML = ""; // Clear previous content

//     const tableWrapper = document.createElement("div");
//   tableWrapper.setAttribute("class", "submission-table-wrapper");

//     const table = document.createElement("table");
//     table.innerHTML = `
//         <thead>
//             <tr>
//                 <th>City , State</th>
//                 <th>Age Group</th>
//                 <th>Medication</th>
//                 <th>Date</th>
//             </tr>
//         </thead>
//         <tbody></tbody>
//     `;

//     const tableBody = table.querySelector("tbody");
// // console.log(tableData,"table data")
//     // Determine the start and end index for the current page
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;

//     // Slice the data for the current page and add rows to the table
//     tableData.slice(startIndex, endIndex).forEach(item => {
//         const row = document.createElement("tr");
//         row.innerHTML = `
//             <td>${item.cityState}</td>
//             <td>${item.ageGroup}</td>
//             <td>${item.drug}</td>
//             <td>${item.date}</td>
//                     `;
//         tableBody.appendChild(row);
//     });

  
//     tableWrapper.appendChild(table);
//     container.appendChild(tableWrapper);

//     // Update the pagination controls
//     updatePaginationControls();
// }

// function updatePaginationControls() {
//     const prevButton = document.getElementById("prev_button");
//     const nextButton = document.getElementById("next_button");

//     prevButton.disabled = currentPage === 1;
//     nextButton.disabled = currentPage * rowsPerPage >= tableData.length;

//     prevButton.onclick = () => {
//         if (currentPage > 1) {
//             currentPage--;
//             createTable();
//         }
//     };

//     nextButton.onclick = () => {
//         if (currentPage * rowsPerPage < tableData.length) {
//             currentPage++;
//             createTable();
//         }
//     };
// }

// // Initial table creation
// createTable();

// document.getElementById('downloadBtn').addEventListener('click', function() {
//   console.log("clcik")
//   var dropdownMenu = document.getElementById('dropdownMenu');
  
//   if (dropdownMenu.style.display === 'block') {
//     dropdownMenu.style.display = 'none';
//   } else {
//     dropdownMenu.style.display = 'block';
//   }
// });

// Hide dropdown when clicking outside of it
// document.addEventListener('click', function(event) {
  
//   var dropdownMenu = document.getElementById('dropdownMenu');
//   var downloadBtn = document.getElementById('downloadBtn');
  
//   if (!downloadBtn.contains(event.target) && !dropdownMenu.contains(event.target)) {
//     dropdownMenu.style.display = 'none';
//   }
// });

// document.getElementById('downloadCSV').addEventListener('click', function(event) {
//   event.preventDefault();
//   const csvData = response.data.formattedTableData.map(item => 
//         `${item.cityState},${item.ageGroup},${item.drug},${item.date}`
//     ).join('\n');

//     const csvContent = `City, State,Age Group,Medication,Date\n${csvData}`;
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.download = 'table-data.csv';
//     link.click();
// });


const tableData = response.data.formattedTableData;
const rowsPerPage = 10;
let currentPage = 1;
let totalPages = Math.ceil(tableData.length / rowsPerPage);

function createTable() {
    const container = document.getElementById("formatted_table_data");
    const tableHeading = document.getElementById("tableHeading");
    tableHeading.innerHTML = `${tableData.length} Total Submission(s)`;

    container.innerHTML = ""; // Clear previous content

    const tableWrapper = document.createElement("div");
    tableWrapper.setAttribute("class", "submission-table-wrapper");

    const table = document.createElement("table");
    table.innerHTML = `
        <thead>
            <tr>
                <th>City, State</th>
                <th>Age Group</th>
                <th>Medication</th>
                <th>Date</th>
            </tr>
        </thead>
        <tbody></tbody>
    `;

//   const downloadBtn = document.createElement("button");
// downloadBtn.id = "downloadBtn";
// downloadBtn.innerText = "Download";

//   container.appendChild(downloadBtn);
// downloadBtn.addEventListener("click",()=>{
//   const csvData = tableData.map(item => 
//         `${item.cityState},${item.ageGroup},${item.drug},${item.date}`
//     ).join('\n');

//     const csvContent = `City, State,Age Group,Medication,Date\n${csvData}`;
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.download = 'table-data.csv';
//     link.click();
// })
  
    const tableBody = table.querySelector("tbody");

    // Determine the start and end index for the current page
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, tableData.length);

    // Slice the data for the current page and add rows to the table
    tableData.slice(startIndex, endIndex).forEach(item => {
        const row = document.createElement("tr");
        row.innerHTML = `
            <td>${item.cityState}</td>
            <td>${item.ageGroup}</td>
            <td>${item.drug}</td>
            <td>${item.date}</td>
        `;
        tableBody.appendChild(row);
    });

    tableWrapper.appendChild(table);
    container.appendChild(tableWrapper);

    // Generate pagination controls
    createPaginationControls();
}

function createPaginationControls() {
    const paginationContainer = document.getElementById("pagination_numbers");
    paginationContainer.innerHTML = ""; // Clear previous pagination

    const maxPagesShown = 3; // Pages shown before and after current
    const firstPage = 1;
    const lastPage = totalPages;

    const paginationButtons = [];

    // Always show the first page
    if (currentPage !== firstPage) {
        paginationButtons.push(createPageButton(firstPage));
    }

    // Add dots if currentPage is beyond the first few pages
    if (currentPage > maxPagesShown + 1) {
        paginationButtons.push(createDots());
    }

    // Show nearby pages based on the current page
    for (let i = Math.max(firstPage, currentPage - maxPagesShown); i <= Math.min(lastPage, currentPage + maxPagesShown); i++) {
        paginationButtons.push(createPageButton(i));
    }

    // Add dots if currentPage is far from the last few pages and lastPage isn't already shown
    if (currentPage < totalPages - maxPagesShown) {
        paginationButtons.push(createDots());
    }

    // Only show the last page if it's not already in the visible range
    if (currentPage + maxPagesShown < lastPage) {
        paginationButtons.push(createPageButton(lastPage));
    }

    // Append buttons to the pagination container
    paginationButtons.forEach(button => paginationContainer.appendChild(button));
}

// Create individual page buttons
function createPaginationControls() {
    const paginationContainer = document.getElementById("pagination_numbers");
    paginationContainer.innerHTML = ""; // Clear existing pagination buttons

    const totalPages = Math.ceil(tableData.length / rowsPerPage);

    if (totalPages <= 1) return; // No need for pagination if only one page

    const createPageButton = (pageNumber) => {
        const button = document.createElement("button");
        button.classList.add("pagination-button");
        button.textContent = pageNumber;
        if (pageNumber === currentPage) {
            button.classList.add("active");
        }
        button.onclick = () => {
            if (pageNumber !== currentPage) {
                currentPage = pageNumber;
                createTable();
                createPaginationControls();
            }
        };
        return button;
    };

    const createDots = () => {
        const dots = document.createElement("span");
        dots.classList.add("pagination-dots");
        dots.textContent = " . . . ";
        return dots;
    };

    // Always show the first page
    paginationContainer.appendChild(createPageButton(1));

    // Show dots if current page is far from the start
    if (currentPage > 3) {
        paginationContainer.appendChild(createDots());
    }

    // Show pages around the current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
        paginationContainer.appendChild(createPageButton(i));
    }

    // Show dots if current page is far from the end
    if (currentPage < totalPages - 2) {
        paginationContainer.appendChild(createDots());
    }

    // Always show the last page
    if (totalPages > 1) {
        paginationContainer.appendChild(createPageButton(totalPages));
    }
}


// Initial table creation
createTable();


         

  
const tooltips = document.querySelectorAll('.custom-tooltip')
$('.highcharts-background').on('click', function() {
    $(tooltips).each(function() {
        $(this).hide();
    });
});


  
})
.catch(error => console.error('Error loading map data:', error));
      // 

    },
    error: function (jqXHR, textStatus, errorThrown) {
        document.querySelector('#result_section').innerHTML = "<h1 class='text-center'>Loading</h1>"
      setTimeout(function(){
              document.querySelector('#result_section').innerHTML = "<h1 class='text-center'>Error occured while fetching. Please try again</h1>"
      }, 4000)  

    }
  })
}
})


